module.exports = __webpack_public_path__ + "assets/img/19.56403874.png";